import { c as _c } from "react/compiler-runtime";
import React, { memo } from 'react';
import Placeholder from 'components/consumer/Placeholder';
import MaterialThumbnailWrapper from './MaterialThumbnailWrapper';
const MaterialThumbnailPlaceholder = t0 => {
  const $ = _c(4);
  const {
    fullHeightThumbnail,
    variant
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Placeholder loading={true} type="rect" className="border-2 border-solid border-white rounded-lg h-full w-full cursor-auto shadow-[inset_0_0_0_5px_#fff]" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== fullHeightThumbnail || $[2] !== variant) {
    t2 = <MaterialThumbnailWrapper fullHeightThumbnail={fullHeightThumbnail} variant={variant}>{t1}</MaterialThumbnailWrapper>;
    $[1] = fullHeightThumbnail;
    $[2] = variant;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default memo(MaterialThumbnailPlaceholder);